import React, { useState } from 'react';
import { Provider, shallowEqual, useDispatch, useSelector } from 'react-redux';
import BaseAvatar from '../avatar';

const BaseHeader = (props) => {
  // const { principal } = useSelector((s) => s.auth, shallowEqual);
  //  현재 로그인한 유저의 이미지 정보
  const { principal } = props;

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '6.2rem',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 28px 12px 28px',
      }}
    >
      <div>{/* 구현할 컴포넌트  */}</div>
      <BaseAvatar
        icon={
          // 'https://gravatar.com/avatar/7f944daa955ae9525aaeadcf22a387f1?s=400&d=robohash&r=x'
          `https://cdn.humanb.kr/${principal.photoPath}/${principal.photoKey}.${principal.photoExt}`
        }
        {...props}
      />
    </div>
  );
};

export default BaseHeader;
